module.exports = __webpack_public_path__ + "img/water-2-0.3999f6a4.png";